/* eslint-disable mobx/missing-observer */

import { Card, CardProps, Tabs, TabsProps } from 'antd';

import styles from './card-tabs.module.css';

type CardTabsProps = Omit<TabsProps, 'size' | 'renderTabBar'> & {
  cardProps?: Omit<CardProps, 'size'>;
};

export const CardTabs = (props: CardTabsProps) => {
  const { cardProps, ...tabsProps }: CardTabsProps = props;

  return (
    <Card {...cardProps} size="small">
      <Tabs
        {...tabsProps}
        size="small"
        renderTabBar={(props, TabBar) => (
          <TabBar {...props} className={styles.tabBar} />
        )}
      />
    </Card>
  );
};
